
import { AmmunitionStockEventRowsEntityDecorator } from './ammunition-stock-event-rows.decorator';
import { AmmunitionStockEventRowsTypeInfoBase } from './ammunition-stock-event-rows.typeinfo.base';
import { AmmunitionStockEventTypeInfo } from './ammunition-stock-event.typeinfo';


export class AmmunitionStockEventRowsTypeInfo extends AmmunitionStockEventRowsTypeInfoBase<any> {
  constructor() {
    super(new AmmunitionStockEventTypeInfo(), new AmmunitionStockEventRowsEntityDecorator());
  }
}

export const AMMUNITION_STOCK_EVENT_ROWS_TYPE: AmmunitionStockEventRowsTypeInfo = new AmmunitionStockEventRowsTypeInfo();



